import React, { useState, useEffect } from 'react';
import dayjs from '~/utils/dayjsConfig';
import { Notifications, DataTable } from '../../../shared';
import { infoTechApi as api } from '../../../api/infoTech';
import { Button } from '@material-ui/core';

const ITSTIckets = () => {
    let [rows, setRows] = useState([]);
    let [notification, setNotification] = useState({ text: null, level: null });
    let [knowledgeBaseEntries, setKnowledgeBaseEntries] = useState([]);

    // Load table
    let getRows = async (kbEntries) => {
        let response = await api.getITSTickets();
        if (response.status === false) {
            setNotification({ text: 'No entries found ' + response.msg, level: 'error' });
            setRows([]);
            return;
        }

        if (response.data.rows) {
            response.data.rows.map((row) => {
                row.createdAt = dayjs(row.createdAt.date).format('MM/DD/YYYY');
                row.responseLinkedOn = row.responseLinkedOn
                    ? dayjs(row.responseLinkedOn.date).format('MM/DD/YYYY HH:mm:ss')
                    : '';
                return row;
            });
        }

        setRows(response.data.rows || []);
    };

    let columns = [
        { accessor: 'id', Header: 'ID' },
        { accessor: 'fsTicketID', Header: 'Freshworks Ticket ID' },
        { accessor: 'initialTicketDesc', Header: 'Problem' },
        {
            accessor: 'itsKnowledgeBaseID',
            Header: 'Knowledge Base',
            editable: true,
            editProps: {
                options: knowledgeBaseEntries.map((entry) => ({ value: entry.id, text: entry.title })),
                type: 'select',
            },
        },
        { accessor: 'createdAt', Header: 'Created At' },
        { accessor: 'responseLinkedBy', Header: 'Response Linked By' },
        { accessor: 'responseLinkedOn', Header: 'Response Linked On' },
        {
            accessor: 'unlink',
            Header: 'Unlink',
            Cell: ({ cell: { value: initialValue }, row, column, saveEdit, editable }) => {
                return (
                    <Button
                        onClick={async () => {
                            let response = await api.unlinkArticleFromTicket(row.original.id);

                            if (response.status === false) {
                                setNotification({ text: "Can't unlink entry " + response.msg, level: 'error' });
                                return;
                            }

                            getRows();
                        }}
                    >
                        Unlink
                    </Button>
                );
            },
        },
    ];

    useEffect(() => {
        const loadData = async () => {
            const kbResponse = await api.getKnowledgeBaseEntries();
            let kbEntries = [];
            if (kbResponse.data && kbResponse.data.rows) {
                kbEntries = kbResponse.data.rows;
                setKnowledgeBaseEntries(kbEntries);
            }
            await getRows(kbEntries);
        };
        loadData();
    }, []);

    return (
        <div>
            <h1>ITS Tickets</h1>
            <Notifications options={notification} />
            <div>
                <DataTable
                    columns={columns}
                    data={rows}
                    editable={true}
                    saveEdit={async ({ id, field, value, row }) => {
                        let item = {};
                        item[field] = value;

                        if (field === 'itsKnowledgeBaseID') {
                            let response = await api.updateITSTicket(id, item);

                            if (response.status === false) {
                                setNotification({ text: 'Failed: ' + response.msg, level: 'error' });
                                return;
                            }
                        }

                        await getRows(knowledgeBaseEntries);
                    }}
                />
            </div>
        </div>
    );
};

export { ITSTIckets };
